/* 🤖 this file was generated by svg-to-ts */
export const matIconSwipeDownAlt: {
  name: 'swipe-down-alt';
  data: string;
} = {
  name: 'swipe-down-alt',
  data: `<svg xmlns="http://www.w3.org/2000/svg" width="24" height="24"><path d="M13 13.9a5 5 0 1 0-2 0v4.27l-1.59-1.59L8 18l4 4 4-4-1.41-1.41L13 18.17V13.9zM15 9c0 1.66-1.34 3-3 3s-3-1.34-3-3 1.34-3 3-3 3 1.34 3 3z"/></svg>`
};
